import React from 'react';
import { Row, Col, Card, CardFooter, CardTitle, CardImg, CardBody, Badge } from 'reactstrap';
import ProductToggle from '../MyList/ProductToggle';
import ProductInfoButton from './productInfoButton';
import { IMAGE_PATH } from '../Shared/Constants/Constants';

const SentListProductCard = (props) => {
    return (
        <Card key={props.product.productId} style={{ width: 450, height: 400 }} className="float-start me-4 mb-4 shadow-sm">
            <CardBody className="overflow-hidden">
                <Row>
                    <Col xs="8">
                        <CardImg
                            width="100%"
                            src={`${IMAGE_PATH}${props.product.mainPhotoUrl}?anchor=middlecenter&mode=pad&format=jpg&height=400&width=400&quality=80`}
                        />
                    </Col>
                    <Col xs="16" className="overflow-auto" style={{ height: 320 }}>
                        <CardTitle tag="h5">{props.product.productNameTlc}</CardTitle>
                        <h6>by {props.product.manufacturerName}</h6>
                        {props.showDescription && (
                            <Row>
                                <Col>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: props.product.productDescription,
                                        }}
                                    />
                                </Col>
                            </Row>
                        )}
                        {props.product.productBillingCodes && (
                            <React.Fragment>
                                <Row className="border-bottom me-2">
                                    <Col>Billing Codes</Col>
                                </Row>
                                {props.product.productBillingCodes.map((codes) => {
                                    return (
                                        <Row key={codes.productBillingCodeId} className="mx-2 pt-1">
                                            <Col>
                                                {codes.billingCode} <Badge color="secondary">{codes.billingTypeCode}</Badge>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </React.Fragment>
                        )}
                    </Col>
                </Row>
            </CardBody>
            <CardFooter>
                <Row>
                    <Col className="text-end">
                        <ProductToggle product={props.product} className="me-2" />
                        <ProductInfoButton productId={props.product.productId} productName={props.product.productName} toggle={props.toggle} />
                    </Col>
                </Row>
            </CardFooter>
        </Card>
    );
};

export default SentListProductCard;
